module.exports = __webpack_public_path__ + "img/clean.10e349ec.svg";